import $u from "@/utils";

const types = ["news", "activity", "official_doc", "application", "other"];
const defTypeState = {
  items: [],
  total: 0,
  lastDoc: null
};
const state = types.reduce((acc, type) => {
  acc[type] = Object.assign({}, defTypeState);
  return acc;
}, {});

export default {
  namespaced: true,
  state,
  mutations: {
    APPEND_ITEMS(state, { type, items }) {
      state[type].items = state[type].items.concat(items);
    },
    UPDATE_PROPERTY(state, { type, data }) {
      $u.each(data, (v, k) => {
        state[type][k] = v;
      });
    }
  },
  actions: {},
  getters: {
    findItem: state => ({ type, id }) => {
      if (type) {
        return state[type].items.find(item => item.temp.id === id);
      } else {
        let res;

        $u.each(state, data => {
          const found = data.items.find(item => item.temp.id === id);
          if (found) {
            res = found;
            return false;
          }
        });

        return res;
      }
    }
  }
};
